import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { accessLocalStorage, exportSelectAllEndpoints, exportDeleteEndpoints } from '../../../services';

import PbxContext from '../../../context/PbxContext';
import Loading from '../../../components/Loading/LoadingModule';
import './EndpointsList.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash, faPlus, faPhone } from '@fortawesome/free-solid-svg-icons';

function EndpointsList() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsChangeFormElements, toggleIsHidden, setItemsSelectedToEdit } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const [loading, setLoading] = useState(true);
  const [phones, setPhones] = useState(() => []);
  const [endpointsSelected, setEndpointsSelected] = useState([]);
  const [disable, setDisable] = useState(true);
  const [filterText, setFilterText] = useState('');

  const history = useHistory();

  const fetchEndpoints = async (accountcode) => {
    let endpointsList = await exportSelectAllEndpoints();
    endpointsList = accountcode.includes('vgs') ? endpointsList : endpointsList.filter((endpoint) => accountcode.includes(endpoint.tenant));
    
    if(endpointsList === undefined) setLoading(true);
    const elements = endpointsList.map((element) => {
      const { pass, transportName, contextName, languageName, busy, captureGroup, maxContacts } = element;
      element['password'] = pass;
      element['transport'] = transportName;
      element['context'] = contextName;
      element['language'] = languageName;
      element['state'] = busy;
      element['pickupGroup'] = captureGroup;
      element['maxContacts'] = maxContacts || 1;

      delete element.pass;
      delete element.transportName;
      delete element.contextName;
      delete element.languageName;
      delete element.captureGroup;

      return element;
    }).filter((element) => !isNaN(Number(element.endpoint)));
    
    setPhones(elements);
    setLoading(false);

    return true;
  };


  const validateUserLogged = useCallback(async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    const { user: { role, idtenant } } = dataUser;
    if (!dataUser) return history.push('/');
    if (dataUser && role !== 'root') return history.push('/home');

    const endpointsFetched = await fetchEndpoints(idtenant);
    return endpointsFetched;
  }, []);

  const handleChangeSelectedEndpoints = (element) => {
    setEndpointsSelected((prevState) => {
      const onlineState = prevState.includes(element) ? [...prevState.filter((e) => e !== element)] : [...prevState, element];
      onlineState.length > 0 ? setDisable(false) : setDisable(true)
      return onlineState;
    });
  };

  const handleClickDelete = async () => {
    const sendDeleteEndpoints = await exportDeleteEndpoints(endpointsSelected);
    if(sendDeleteEndpoints.length === undefined) {
      toggleIsHidden('#alert-confirm-endpoints-delete');
      return toggleIsChangeFormElements('alert-endpoints-not-delete', 'column is-half is-offset-one-quarter message is-danger is-active');
    };
    toggleIsHidden('#alert-confirm-endpoints-delete');
    setDisable(true);
    toggleIsHidden('#buttons');
    validateUserLogged();
    return;
  };

  const handleClickUpdate = async () => {
    setItemsSelectedToEdit(endpointsSelected);
    return history.push('/config/ramal/id');
  };

  const handleChangeSelectAll = () => {
    const inputSelectAll = document.getElementById('select-all');
    const selectEndopointsphones = phones.map((element) => {
      const getCheckbox = document.getElementById(element.endpoint);
      if(inputSelectAll.checked) {
        getCheckbox.checked = true;
        setDisable(false);
        return element.endpoint;
      } else {
        getCheckbox.checked = false;
        setDisable(true);
        return null;
      }
    });
    const result = selectEndopointsphones[0] === null ? [] : selectEndopointsphones;
    return setEndpointsSelected(result);
  };

  const filteredPhones = phones.filter((phone) => {
    const searchText = filterText.toLowerCase();
    return (
      phone.endpoint.toString().includes(searchText) ||
      (phone.password && phone.password.toLowerCase().includes(searchText)) ||
      (phone.callerid && phone.callerid.toLowerCase().includes(searchText)) ||
      (phone.transport && phone.transport.toLowerCase().includes(searchText)) ||
      (phone.context && phone.context.toLowerCase().includes(searchText)) ||
      (phone.language && phone.language.toLowerCase().includes(searchText)) ||
      (phone.codec && phone.codec.toLowerCase().includes(searchText))
    );
  });

  useEffect(() => {
    let cancel = false;
    
    if (cancel) return;
    validateUserLogged();

    return () => {
      cancel = true
    };
  }, [validateUserLogged]);

  return (
    <div>
      {
        loading ?
          <Loading />
        :
        <div className="endpoints-list-container">
          <div className="endpoints-header">
            <div className="endpoints-title-wrapper">
              <div className="endpoints-title-left">
                <svg className="endpoints-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <div>
                  <h1 className="endpoints-title">Ramais</h1>
                  <p className="endpoints-subtitle">Gerencie os ramais do sistema</p>
                </div>
              </div>
              <div className="endpoints-actions">
                <Link to="/config/ramal/create" className="btn-endpoints btn-new-endpoint">
                  <FontAwesomeIcon icon={ faPlus } className="btn-icon" />
                  Novo Ramal
                </Link>
                <button 
                  className="btn-endpoints btn-edit-endpoint" 
                  disabled={disable} 
                  onClick={() => handleClickUpdate()}
                >
                  <FontAwesomeIcon icon={ faPen } className="btn-icon" />
                  Editar
                </button>
                <button 
                  id="buttons" 
                  className="btn-endpoints btn-delete-endpoint" 
                  disabled={disable} 
                  onClick={() => {
                    toggleIsHidden('#alert-confirm-endpoints-delete');
                    toggleIsHidden('#buttons');
                  }}
                >
                  <FontAwesomeIcon icon={ faTrash } className="btn-icon" />
                  Excluir
                </button>
              </div>
            </div>
          </div>

          <div className="alerts-section">
            <div id="alert-endpoints-not-delete" className="alert-message alert-danger is-hidden">
              <div className="alert-header">
                <span>Atenção!</span>
                <button className="alert-close" aria-label="delete" onClick={() => toggleIsHidden('#alert-endpoints-not-delete')}>×</button>
              </div>
              <div className="alert-body">
                Não foi possível deletar os ramais selecionados.
              </div>
            </div>

            <div id="alert-confirm-endpoints-delete" className="alert-message alert-danger is-hidden">
              <div className="alert-header">
                <span>Atenção!</span>
                <button className="alert-close" aria-label="delete" onClick={() => toggleIsHidden('#alert-confirm-endpoints-delete')}>×</button>
              </div>
              <div className="alert-body">
                Tem certeza que quer deletar os ramais selecionados?
              </div>
              <div className="alert-actions">
                <button className="btn-alert btn-alert-confirm" onClick={() => handleClickDelete()}>
                  <FontAwesomeIcon icon={ faTrash } />
                  Confirmar
                </button>
                <button className="btn-alert btn-alert-cancel" onClick={() => {
                  toggleIsHidden('#alert-confirm-endpoints-delete');
                  toggleIsHidden('#buttons');
                }}>
                  Cancelar
                </button>
              </div>
            </div>
          </div>

          <div className="filter-section">
            <div className="filter-input-wrapper">
              <svg className="filter-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
              <input
                type="text"
                className="filter-input"
                placeholder="Filtrar por ramal, senha, nome, protocolo, contexto, codec..."
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />
              {filterText && (
                <button className="filter-clear" onClick={() => setFilterText('')}>
                  ×
                </button>
              )}
            </div>
            <div className="filter-results">
              Exibindo {filteredPhones.length} de {phones.length} ramal(is)
            </div>
          </div>

          <div className="endpoints-table-wrapper">
            <table className="endpoints-table">  
              <thead className="endpoints-table-header">
                  <tr>
                  <th className="checkbox-cell">
                    <input id="select-all" type="checkbox" onClick={() => handleChangeSelectAll()}/>
                  </th>
                  <th>Ramal</th>
                  <th>Senha</th>
                  <th>Nome</th>
                  <th>Protocolo</th>
                  <th>Previlégios</th>
                  <th>DTMF</th>
                  <th>Linguagem</th>
                  <th>Codec</th>
                  <th>NAT</th>
                  <th>Ocupado</th>
                  <th>Max. Disp.</th>
                  <th>Grupo Atendedor</th>
                  <th>Grupo de Captura</th>
                  </tr>
              </thead>
              <tbody>
              {
                filteredPhones.map((phone) => {
                  const { endpoint, password, callerid, transport, context, language, codec, dtmf, state, maxContacts, callGroup, pickupGroup, nat } = phone;
                  return (
                    <tr key={ endpoint }>
                      <td className="checkbox-cell"><input id={ endpoint } type="checkbox" value={endpoint} onClick={ (e) => handleChangeSelectedEndpoints(e.target.value)}/></td>
                      <td>{endpoint}</td>
                      <td>{password}</td>
                      <td>{callerid}</td>
                      <td>{transport}</td>
                      <td>{context}</td>
                      <td>{dtmf}</td>
                      <td>{language}</td>
                      <td>{codec}</td>
                      <td>{nat}</td>
                      <td>{state}</td>
                      <td>{maxContacts || 1}</td>
                      <td>{callGroup}</td>
                      <td>{pickupGroup}</td>
                    </tr>)
                })
              }
              </tbody>
            </table>
          </div>
        </div>
      }
    </div>
  );
}

export default EndpointsList;
